import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import BaseObjectField from './BaseObjectField';

const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 2
  },
  header: {
  },
});

const FieldsetComponent = props => {
  const { classes, schema, uiSchema, children, name, formContext } = props;
  const uiOptions = uiSchema['ui:options'];
  const displayTitle =
    uiOptions && uiOptions.displayTitle !== undefined
      ? uiOptions.displayTitle
      : true;
  const title =
    displayTitle &&
    (uiSchema['ui:title'] ||
      (schema.title !== undefined ? schema.title : null));
  const description = uiSchema['ui:description'] || schema.description;
  const readonlyHidden = name === 'tarkastajan_kuittaus' && formContext.formStatus === 'signed';
  
  return (
    <div className={classes.root}>
      {(title || description) && !readonlyHidden && (
        <header className={classes.header}>
          {title && (
            <Typography type="subheading" gutterBottom>
              {uiSchema['ui:title'] || title}
            </Typography>
          )}
          {description && (
            <Typography type="body1">
              {uiSchema['ui:description'] || schema.description}
            </Typography>
          )}
        </header>
      )}
      {children}
    </div>
  );
};

FieldsetComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  schema: PropTypes.object.isRequired,
  idSchema: PropTypes.object.isRequired,
  uiSchema: PropTypes.object.isRequired,
  errorSchema: PropTypes.object.isRequired,
  registry: PropTypes.object.isRequired,
  name: PropTypes.string,
  options: PropTypes.array,
};

FieldsetComponent.defaultProps = {
  options: [],
};

const enhance = compose(
  withProps({
    RootComponent: withStyles(styles)(FieldsetComponent),
    options: [],
  })
);

const FieldsetField = enhance(BaseObjectField);

export default FieldsetField;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/fields/FieldsetField.js